import { Badge, Box, Text, Group } from "@mantine/core";
import EperuveTypeHeader from "./compenents/EpreuveTypeHeader";

const EpreuveDictee = ({ epreuve }) => {
    // Parse the JSON string from consigne to get temps_lecture
    const getTempsEstime = () => {
        if (!epreuve?.consigne || !epreuve.consigne[0]) return null;

        try {
            const consigneObj = JSON.parse(epreuve.consigne[0]);
            console.log('EpreuveDicte - Parsed consigne:', consigneObj);
            return consigneObj.temps_lecture;
        } catch (error) {
            console.error('Error parsing consigne JSON:', error);
            return null;
        }
    };

    const tempsEstime = getTempsEstime();

    console.log('EpreuveDicte - Full epreuve data:', epreuve);
    console.log('EpreuveDicte - Temps estimé:', tempsEstime);

    return (
        <Box>
            <EperuveTypeHeader epreuve={epreuve} />
            {
                console.log("epreuve", epreuve)
            }
            <Box mt={15}>
                <Group>
                    {epreuve?.bareme && (
                        <Badge color="green" size="lg" mb={10}>
                            Barème: {epreuve.bareme}
                        </Badge>
                    )}
                </Group>
                <Group mb={10}>
                    <Text size={"xl"} weight={500}>Correction :</Text>
                </Group>
                {epreuve?.correction_dp && epreuve.correction_dp.length > 0 && (
                    <Box>
                        <Text size="sm" weight={500} mb={5}>Mot(s) attendu(s) :</Text>
                        <Group spacing="xs">
                            {epreuve.correction_dp.map((choice, index) => (
                                <Badge
                                    key={index}
                                    color="blue"
                                    variant="outline"
                                    size="lg"
                                >
                                    {choice}
                                </Badge>
                            ))}
                        </Group>
                        {tempsEstime && (
                            <Box mt={10}>
                                <Text size="sm" weight={500} mb={5}>Temps estimé: </Text>
                                <Badge color="orange" size="lg">
                                    {tempsEstime} secondes
                                </Badge>
                            </Box>
                        )}
                    </Box>
                )}
            </Box>
        </Box>
    );
}

export default EpreuveDictee;